import { useState } from "react";
import { ServiceBrowser } from "@/pages/public/ServicesPublic";
import { OrderModal } from "@/components/shared/OrderModal";
import { PageHeader } from "@/components/shared/DashKit";
import { useContent } from "@/context/ContentContext";

export default function CatalogCustomer() {
  const { t } = useContent();
  const [service, setService] = useState(null);
  const [open, setOpen] = useState(false);
  return (
    <div>
      <PageHeader title={t("services.page.title", "Catalogue de services")} subtitle={t("services.page.subtitle", "Parcourez et commandez directement depuis le catalogue.")} />
      <ServiceBrowser onOrder={(s) => { setService(s); setOpen(true); }} />
      <OrderModal service={service} open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
